import maInputSelect from '@/components/input/modules/select'

export default {
  name: 'formExport',

  data: function () {
    return {
      formFilter: null
    }
  },

  props: {
    filterFormOptions: {
      type: Array
    },

    isLoading: {
      type: Boolean,
      default: false
    }
  },

  components: {
    maInputSelect
  },

  methods: {
    handleSelectFilterChange (event) {
      this.formFilter = event
      this.$emit('onHandleExportFilterChange', this.formFilter)
    },

    handleExportFormClick () {
      this.$emit('onHandleExportFormClick')
    },

    resetData () {
      this.formFilter = null
      this.$emit('onHandleResetExportData')
    }
  }
}
